<template>
  <TableDocumentType />
</template>
<script>
import TableDocumentType from "./components/tableDocumentType";
export default {
  components: {
    TableDocumentType,
  },
  methods: {},
};
</script>
<style></style>
